import AES from 'crypto-js/aes'
import encHex from 'crypto-js/enc-hex'

import VueSimpleAlert from "vue-simple-alert"
import {userService} from "@/services"

import dateformat, { masks } from "dateformat";
import { config } from "../services/config";

function coloresGraficos(){
  return [
    "rgb(228, 26, 28)",  "rgb(55, 126, 184)",  "rgb(77, 175, 74)",  "rgb(152, 78, 163)",  "rgb(255, 127, 0)",  
    "rgb(255, 255, 51)",  "rgb(166, 86, 40)",  "rgb(247, 129, 191)",  "rgb(153, 153, 153)",  "rgb(242, 148, 0)",  
    "rgb(204, 204, 0)",  "rgb(178, 223, 138)",  "rgb(31, 120, 180)",  "rgb(106, 61, 154)",  "rgb(255, 187, 120)",  
    "rgb(166, 206, 227)",  "rgb(178, 223, 138)",  "rgb(251, 154, 153)",  "rgb(253, 191, 111)",  "rgb(202, 178, 214)",  
    "rgb(61, 61, 61)",  "rgb(240, 163, 255)",  "rgb(0, 153, 143)",  "rgb(255, 194, 10)",  "rgb(41, 128, 185)",  
    "rgb(158, 94, 243)",  "rgb(255, 77, 148)",  "rgb(255, 242, 0)",  "rgb(239, 71, 111)",  "rgb(0, 209, 178)",  
    "rgb(0, 128, 128)",  "rgb(178, 102, 255)",  "rgb(255, 0, 0)",  "rgb(255, 255, 153)",  "rgb(0, 0, 255)",  
    "rgb(0, 255, 0)",  "rgb(128, 0, 128)",  "rgb(255, 128, 0)",  "rgb(128, 128, 128)",  "rgb(0, 0, 0)"];
}

function encrypt(data){
  if(config.env == 'production'){
    let key = encHex.parse("4a7e123d71b24e70616b42aa228fbb6c");
    let iv =  encHex.parse("f2a183b31d6c4278a31e1f9b73cb9d1a");

    data = AES.encrypt(data, key, {iv:iv}).toString();
  }

  return data;
}

function txtBtnCargar(estado){
  if(estado == 'A' || estado == 'R' || estado == 'V'){
    return "Reemplazar";
  }else{
    return "Buscar";
  }
}

//lo paso a json(string) y luego a base64 encode
//objeto => string
function je64(data){
  return safeBtoa(JSON.stringify(data));
}

function safeBtoa(str){
  // Convertimos el string a una serie de bytes UTF-8
  const bytes = new TextEncoder().encode(str);
  // Convertimos esos bytes a una cadena que btoa pueda manejar
  const binString = String.fromCodePoint(...bytes);
  return btoa(binString);
}

//lo paso de bse64 a json(string), luego a objeto
//string => objeto
function jd64(data){
  return JSON.parse(atob(data));
}

function alerta(data){
  if(data.status == 'danger'){
    data.status = 'error';
  }
  VueSimpleAlert.alert(data.msg,'',data.status);
}

function regla3(total, no_total){
  if(total == 0){
    return 0;
  }
  return (no_total*100/total).toFixed(1);
}

function pintaColor(valor){
  if(valor < 41){
    return "red-bg text-light";
  }
  if(valor < 81){
    return "yellow-bg text-light";
  }
  if(valor > 0){
    return "navy-bg text-light";
  }
  return "";
}

function tienePermiso(){
  if(userService.getUser().permiso == "1"){
    return true;
  }
  return false;
}

function mostrarFiltroEmpresa(){
  if(userService.getUser().id_empresa == 0){
    return true;
  }
  return false;
}

function mostrarFiltroSucursal(){
  if(userService.getUser().id_empresa == 0){
    return true;
  }
  return false;
}

function formatearRut(rut) {
  if (!rut) return '';

  // Elimina caracteres no numéricos y el guion, si existe
  rut = rut.replace(/[^0-9kK]+/g, '').toUpperCase();

  const rutBody = rut.slice(0, -1);
  const rutDv = rut.slice(-1);
  let rutFormateado = '';

  // Agrega los puntos de mil y guion antes del dígito verificador
  for (let i = rutBody.length - 1, j = 0; i >= 0; i--, j++) {
    rutFormateado = rutBody[i] + rutFormateado;
    if (j % 3 === 2 && i !== 0) {
      rutFormateado = '.' + rutFormateado;
    }
  }

  return rutFormateado + '-' + rutDv;
}

function DateToFecha(date, formato){
  masks.fecha = formato;
  return dateformat(date, "fecha");
}

function fechaToDate(date){
  let fecha = date.split("-");
  return new Date(fecha[2], fecha[1]-1, fecha[0]);
}

function importFecha(import_date){
  let fecha = import_date.split("-");
  return new Date(fecha[0], fecha[1]-1, fecha[2]);
}

//ordena datos de graficos de estado de documentos, de mayor a menor % aprobado
function ordenarPorAprobado(data){
  return Object.values(data).sort((a, b) => parseFloat(b.aprobado || 0) - parseFloat(a.aprobado || 0));
}

export const utils = {
  pintaColor,
  alerta,
  mostrarFiltroEmpresa,
  mostrarFiltroSucursal,
  tienePermiso,
  regla3,
  txtBtnCargar,
  formatearRut,
  DateToFecha,
  importFecha,
  jd64,
  je64,
  encrypt,
  fechaToDate,
  coloresGraficos,
  ordenarPorAprobado
}
